import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Security = () => {
  const points = [
    "No contract upgrades",
    "No backdoor controls",
    "Fixed supply",
    "Public on-chain verification"
  ];

  return (
    <section className="py-24 px-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        className="max-w-4xl mx-auto glass-panel rounded-[3rem] p-10 md:p-16 text-center relative overflow-hidden border border-green-500/20"
      >
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-green-500/5 blur-[100px] pointer-events-none" />
        
        <div className="relative inline-flex items-center justify-center mb-8">
          <div className="absolute inset-0 bg-green-400/20 rounded-full blur-xl animate-pulse" />
          <SafeIcon name="Shield" className="w-16 h-16 text-green-400 relative z-10" />
        </div>
        
        <h2 className="text-3xl md:text-5xl font-bold mb-12 text-white">Security & Transparency</h2>
        
        <div className="grid sm:grid-cols-2 gap-6 text-left max-w-2xl mx-auto relative z-10">
          {points.map((point, i) => (
            <div key={i} className="flex items-center gap-4 bg-[#ffffff05] p-5 rounded-2xl border border-white/5 hover:border-green-500/30 transition-colors">
              <SafeIcon name="Lock" className="text-green-400 shrink-0 w-5 h-5" />
              <span className="font-semibold text-slate-200 text-lg">{point}</span>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Security;